module.exports = __webpack_public_path__ + "static/media/flag-ug.dcd4253a.webp";